import {FeatureId} from '@mc/react-mapio';

/**
 * Porovná dvě kolekce featureId jako množiny — bez ohledu na pořadí a typ (number/string).
 * Slouží jako equality guard při synchronizaci výběru mezi mapou a atributovou tabulkou,
 * aby se výběr nepřepisoval stejnou hodnotou a nespouštěl nekonečnou smyčku efektů.
 */
export const sameFeatureIdSet = (a?: Array<FeatureId | undefined | null>, b?: Array<FeatureId | undefined | null>): boolean => {
    const sa = new Set((a ?? []).map(Number));
    const sb = new Set((b ?? []).map(Number));
    if (sa.size !== sb.size) return false;
    for (const x of sa) {
        if (!sb.has(x)) return false;
    }
    return true;
};
